import {Component, Input} from '@angular/core';

@Component({
    selector: 'db-websites-controls-card',
    templateUrl: './websites-controls-card.component.html',
    styleUrls: ['./websites-controls-card.component.scss'],
    standalone: false
})
export class WebsitesControlsCardComponent {

  @Input() isAdditionalWebsite = false;
  @Input() icon: string;
  @Input() title: string;
  @Input() disabled = false;
  @Input() isUploading = false;
  @Input() loading? = false;
  @Input() showMore?: boolean = false;

  constructor() { }

}
